import { render, staticRenderFns } from "./CountryContentForm.vue?vue&type=template&id=b4f450ba&scoped=true&"
import script from "./CountryContentForm.vue?vue&type=script&lang=js&"
export * from "./CountryContentForm.vue?vue&type=script&lang=js&"
import style0 from "./CountryContentForm.vue?vue&type=style&index=0&id=b4f450ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f450ba",
  null
  
)

export default component.exports